import { createFileRoute } from '@tanstack/react-router';
import { ApprovalsQueue } from '../../features/approvals/components/ApprovalsQueue.js';
import { usePageTitle } from '../../lib/hooks.js';

export const Route = createFileRoute('/_auth/approvals')({
  component: ApprovalsPage,
});

function ApprovalsPage() {
  usePageTitle('Approvals');
  return <ApprovalsQueue />;
}
